module.exports = __webpack_public_path__ + "static/media/shrek-no-dab.0be7510d.png";